import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../GlobalContext";
import {perkiraankhusus, perkiraan} from "../services/PerkiraanService";

const TransferManasuka = () => {
  const { api } = useGlobalContext();

  const [tglTransaksi, setTglTransaksi] = useState("");
  const [data, setData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [jurnalData, setJurnalData] = useState([]);
  const [keterangan, setKeterangan] = useState("");
  const [noJurnal, setNoJurnal] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().substr(0, 10);
    setTglTransaksi(today);
  }, []);

  const fetchData = async () => {
    try {
      const response = await api.get(`/api/akuntansi/transfermanasuka/${tglTransaksi}`);
      setData(response.data);
      setCheckedItems(new Array(response.data.length).fill(false));
      setSelectedIds([]);
    } catch (err) {
      alert("Gagal mengambil data transfer Manasuka");
      console.error(err);
    }
  };

  const handleCheckChange = (index) => {
    const updatedChecked = [...checkedItems];
    updatedChecked[index] = !updatedChecked[index];
    setCheckedItems(updatedChecked);

    const id = data[index].notransaksi;
    setSelectedIds((prev) =>
      updatedChecked[index]
        ? [...prev, id]
        : prev.filter((item) => item !== id)
    );
  };

  const handleCekAll = () => {
    setCheckedItems(new Array(data.length).fill(true));
    setSelectedIds(data.map((item) => item.notransaksi));
  };

  const handleUncekAll = () => {
    setCheckedItems(new Array(data.length).fill(false));
    setSelectedIds([]);
  };

  const handleProsesJurnal = async () => {
    const selectedData = data.filter((_, idx) => checkedItems[idx]);

    if (selectedData.length === 0) {
      alert("Silakan centang minimal satu data untuk memproses jurnal.");
      return;
    }

    const [year, month] = tglTransaksi.split("-");
  const periode = `${month}.${year.slice(-2)}`; 
  const kode = "JT";

  try {
    const res = await api.get(`/api/akuntansi/getnourutjurnal/${kode}/${periode}`);
    setNoJurnal(res.data.jnobukti);  
  } catch (err) {
    console.error("❌ Gagal ambil nomor jurnal:", err);
    alert("Tidak bisa ambil nomor jurnal otomatis");
    return;
  }

    const totalKredit = selectedData.reduce(
      (acc, item) => acc + parseFloat(item.kredit || 0),
      0
    );

    const [kdKas, kdSimpsuka] = await Promise.all([
      perkiraankhusus(api, "kas"),
      perkiraankhusus(api, "simpsuka"),
    ]);
    const [perkKas, perkSimpsuka] = await Promise.all([
      perkiraan(api, kdKas),
      perkiraan(api, kdSimpsuka),
    ]);

    const newJurnal = [
      {
        kdperk: kdKas || "", 
        uraianperk: perkKas || "Perkiraan tidak ditemukan",
        debet: totalKredit,
        kredit: 0,
      },
      {
        kdperk: kdSimpsuka || "", 
        uraianperk: perkSimpsuka  || "Perkiraan tidak ditemukan",
        debet: 0,
        kredit: totalKredit,
      },
    ];    
    setJurnalData(newJurnal);
  };

  const handleBatalProsesJurnal = () => {
    setJurnalData([]); 
          setNoJurnal(""); 
   
  };

  const handleSave = async () => {
    /*const selectedNotransaksi = data
    .filter((_, idx) => checkedItems[idx])
    .map((item) => item.notransaksi);*/

    if (selectedIds.length === 0) {
      alert("Pilih minimal satu transaksi untuk disimpan");
      return;
    }

    if (jurnalData.length === 0) {
      alert("Belum ada data jurnal untuk disimpan.");
      return;
    }

    try {
      await api.post("/api/akuntansi/savejurnalmanasuka", {
        notransaksiList: selectedIds,
      });

      const jnobukti = noJurnal;
      const jtanggal = tglTransaksi;

      const payload = {
        jnobukti,
        jtanggal,
        uraian1: keterangan,
        details: jurnalData.map((row) => ({
          jnobukti,
          kdperk: row.kdperk,
          uraianperk: row.uraianperk,
          debet: parseFloat(row.debet),
          kredit: parseFloat(row.kredit),
        })),
      };

      await api.post("/api/akuntansi/savetransfer", payload);

      alert("Jurnal & Transfer berhasil disimpan");

      setData((prevData) =>
        prevData.map((item) =>
          selectedIds.includes(item.notransaksi)
            ? { ...item, jurnal: 1 } 
            : item
        )
      );

      setCheckedItems(new Array(data.length).fill(false));
      setSelectedIds([]);
      setJurnalData([]);
      setKeterangan("");
      setNoJurnal(""); 

    } catch (err) {
      console.error("❌ Gagal menyimpan:", err);
      alert(err.response?.data?.message || "Gagal menyimpan data");
    }
  };

  const totalKredit = data.reduce((acc, item) => acc + parseFloat(item.kredit || 0), 0);

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-info text-white">
          <h5 className="mb-0">Transfer Simpanan Manasuka</h5>
        </div>

        <div className="card-body">
          <div className="card mb-3">
            <div className="card-body">
              <div className="form-inline">
                <label className="mr-2 font-weight-bold">Tanggal Transaksi</label>
                <input
                  type="date"
                  className="form-control mr-2"
                  value={tglTransaksi}
                  onChange={(e) => setTglTransaksi(e.target.value)}
                />
                <button onClick={fetchData} className="btn btn-primary">
                  Display
                </button>
              </div>
            </div>
          </div>

          {/* Tabel Transfer Manasuka */}
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-sm">
                  <thead className="thead-light">
                    <tr>
                      <th className="text-center">Cek</th>
                      <th>Tanggal</th>
                      <th>No. Transaksi</th>
                      <th>No Anggota</th>
                      <th>Nama</th>
                      <th>Unit</th>
                      <th>Kredit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, idx) => (
                      <tr
                        key={idx}
                        className={item.jurnal === 1 || item.jurnal === "1" ? "table-secondary" : ""}
                      >
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={checkedItems[idx] || false}
                            onChange={() => handleCheckChange(idx)}
                            disabled={item.jurnal === 1 || item.jurnal === "1"} 
                          />
                        </td>
                        <td>{(item.tgltransak || "").split("T")[0]}</td>
                        <td>{item.notransaksi}</td>
                        <td>{item.noanggota}</td>
                        <td>{item.nama}</td>
                        <td>{item.unitkerja}</td>
                        <td className="text-right">
                          {parseFloat(item.kredit || 0).toLocaleString("id-ID")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="6" className="text-center font-weight-bold">
                        Total
                      </td>
                      <td className="text-right font-weight-bold">
                        {totalKredit.toLocaleString("id-ID")}
                      </td>
                    </tr>
                  </tfoot>
                </table>
                <div className="mt-3 d-flex gap-2">
                  <button className="btn btn-secondary btn-sm" onClick={handleCekAll}>
                    Cek All
                  </button>&nbsp;
                  <button className="btn btn-secondary btn-sm" onClick={handleUncekAll}>
                    Uncek
                  </button>&nbsp;
                  <button className="btn btn-success btn-sm" onClick={handleProsesJurnal}>
                    Proses Jurnal
                  </button>&nbsp;
                  <button className="btn btn-danger btn-sm" onClick={handleBatalProsesJurnal}>
                    Batal Proses Jurnal
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* Form Jurnal */}
          <div className="card mt-4">
            <div className="card-header bg-warning">
              <strong>Form Jurnal</strong>
            </div>
            <div className="card-body">
              <div className="mb-4 border p-3">
                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">No. Jurnal</label>
                  <div className="col-sm-10">
                    <input
                    type="text"
                    className="form-control"
                    placeholder="No. Jurnal"
                    value={noJurnal}
                    onChange={(e) => setNoJurnal(e.target.value)}
                  />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-2 col-form-label">Tanggal</label>
                  <div className="col-sm-10">
                    <input
                      type="text"
                      className="form-control"
                      readOnly
                      value={tglTransaksi}
                    />
                  </div>
                </div>

                <div className="form-group row">
              <label className="col-sm-2 col-form-label">Keterangan</label>
              <div className="col-sm-10">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Keterangan"
                  value={keterangan}                
                  onChange={(e) => setKeterangan(e.target.value)}  
                />
              </div>
            </div>

                {/* Tabel Jurnal */}
                <table className="table table-bordered table-sm">
                  <thead className="thead-light text-center">
                    <tr>
                      <th>No. Perk</th>
                      <th>Perkiraan</th>
                      <th>Debet</th>
                      <th>Kredit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {jurnalData.length > 0 ? (
                      jurnalData.map((row, i) => (
                        <tr key={i}>
                          <td className="text-center">{row.kdperk}</td>
                          <td>{row.uraianperk.trim()}</td>
                          <td className="text-right">{parseFloat(row.debet).toLocaleString('id-ID')}</td>
                          <td className="text-right">{parseFloat(row.kredit).toLocaleString('id-ID')}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center text-muted">Belum ada data jurnal.</td>
                      </tr>
                    )}
                  </tbody>
                  {jurnalData.length > 0 && (
                    <tfoot>
                      <tr className="font-weight-bold">
                        <td colSpan="2" className="text-center">Total</td>
                        <td className="text-right">
                          {jurnalData.reduce((acc, row) => acc + parseFloat(row.debet), 0).toLocaleString('id-ID')}
                        </td>
                        <td className="text-right">
                          {jurnalData.reduce((acc, row) => acc + parseFloat(row.kredit), 0).toLocaleString('id-ID')}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>

                {jurnalData.length > 0 && (
                  <div className="text-right mt-3">
                    <button className="btn btn-primary" onClick={handleSave}>
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferManasuka;
